import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  SyncDataModalForCreatingContainer, type SyncDataModalForCreatingContainerProps,
} from './syncDataModalForCreating.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    CreateGooogleSheetMap: SyncDataModalForCreatingContainerProps;
  }
}
modalRenderer.register('CreateGooogleSheetMap', SyncDataModalForCreatingContainer);
